import { useEffect, useState } from "react";
import "../assets/styles/components/modal.scss";
import CloseRounded from "../assets/icons/close-rounded";

export default function Modal({ content, closeModal, header_close = true }) {
  const [close_modal_effect, setCloseModalEffect] = useState("");

  useEffect(() => {
    document.body.style.overflow = "hidden";
  }, []);

  const handleCloseModal = () => {
    setCloseModalEffect("close-effect");
    setTimeout(() => {
      document.body.style.overflow = "auto";
      closeModal();
    }, 500);
  };

  return (
    <div
      className={`modal position-fixed px-3 w-100 h-100 py-4 d-flex justify-content-center align-items-center ${close_modal_effect}`}
    >
      <div className="modal__content shadow-lg overflow-auto ">
        <div
          className={`close-modal mb-2 position-sticky d-flex w-100 ${
            header_close ? "d-inline-block" : "d-none"
          }`}
        >
          <span
            id="close-modal-button"
            className="p-1 ms-auto"
            onClick={() => handleCloseModal()}
          >
            <CloseRounded size={24} color="#20419a" />
          </span>
        </div>
        <div className="inner-content px-3 pt-2">{content}</div>
      </div>
    </div>
  );
}
